export default __webpack_public_path__ + "static/media/complete_logo_devsuperior.b49596a3.svg";